import MortalityCauses from "@/modules/MortalityCauses/pages/MortalityCauses"

export default [
	{
		path: '/causaMortalidade',
		name: 'causaMortalidade',
		component: MortalityCauses
	}
];
